import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=45e0c7b3&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./Card.vue?vue&type=style&index=0&id=45e0c7b3&prod&lang=scss"
import style1 from "./Card.vue?vue&type=style&index=1&id=45e0c7b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e0c7b3",
  null
  
)

export default component.exports